
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";
import notifications from "../../lib/notifications";
import { formatPhoneNumber } from "@/utils";

const orderModule = getModule(OrderModule);

@Component
export default class OrderConsigneeContacts extends Vue {
  add() {
    orderModule.showAddConsigneeContactEntryModal();
  }

  search() {
    orderModule.showConsigneeContactSearchModal();
  }

  editContact(contact) {
    orderModule.showEditConsigneeContactEntryModal(contact);
  }

  get consigneeContacts() {
    return orderModule.currentOrderConsigneeContacts;
  }

  get shipsWithOrders(): Array<{ number: number }> {
    return orderModule.currentOrderShipsWithOrders;
  }

  canAccessPortal(contact) {
    return contact.phoneType == 'M' && contact.textMessageOptIn && orderModule.currentOrder.isPortalAccessible==true
  }

  getFormattedPhoneNumber(phoneNumber) {
    return phoneNumber ? formatPhoneNumber(phoneNumber) : "";
  }

  async removeContact(contact) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      `Are you sure you want to remove the contact? This action cannot be undone.`
    );

    if (confirmed) {
      try {
        await orderModule.removeContactFromOrder({
          orderHeaderNumber: orderModule.currentOrder.headerNumber,
          contactId: contact.id
        });
        
        if (this.shipsWithOrders && this.shipsWithOrders.length > 0) {
          const confirmedAll = await this.$bvModal.msgBoxConfirm(
            `Do you want to remove the consignee contact from all linked orders?`
          );
          if (confirmedAll) {
            this.shipsWithOrders.forEach(async (order) => {
            if(orderModule.currentOrder.headerNumber !== order.number) {
                  await orderModule.removeContactFromOrder({
                    orderHeaderNumber: order.number,
                    contactId: contact.id
                  });
                }
            });
          } 
        }
        notifications.success("Contact Removed", "Contact successfully removed");
      } catch (ex) {
        notifications.error("Contact Not Removed", "Failed to remove contact from order", ex);
      }
    }
  }


  async sendAccessCode(contact) {
    const confirmed = await this.$bvModal.msgBoxConfirm(
      `Are you sure you want to send a text message with the access code to the contact?`
    );

    if (confirmed) {
      try {
        await orderModule.sendAccessCode({
          orderHeaderNumber: orderModule.currentOrder.headerNumber,
          contactId: contact.id
        });
        notifications.success("Sent", "Access Code successfully sent.");
      } catch (ex) {
        notifications.error("Error Sending", "Failed to send Access Code to contact", ex);
      }
    }
  }
}
